<template>
  <div class="header">
    <nav class="uk-navbar-container uk-margin uk-margin-remove-bottom" uk-navbar>
      <div class="uk-navbar-left">
        <a class="uk-navbar-item uk-logo uk-margin-left" href="#">
          <img width="70" height="70" src="../assets/logo-white.png" />
        </a>
      </div>
      <div class="uk-navbar-right" v-show="isConnected">
        <ul class="uk-navbar-nav">
          <li>
            <router-link to="/">
              <a href="#" class="uk-text-bold">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: home"></span>
              </a>
            </router-link>
          </li>
          <li>
            <router-link to="/checks">
              <a href="#" class="uk-text-bold">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: check"></span>
              </a>
            </router-link>
          </li>
          <li>
            <router-link to="/nomenclature">
              <a href="#" class="uk-text-bold">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: link"></span>
              </a>
            </router-link>
          </li>
          <li>
            <router-link to="/settings">
              <a href="#" class="uk-text-bold">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: cog"></span>
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      isConnected: true,
      currentUser: {}
    };
  },
  mounted() {
    const self = this;
    self.isConnected = localStorage.currentUser != null;
  },

  methods: {}
};

</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
  text-decoration: none;
}

.uk-navbar-container {
  background-color: #309eb5;
}
</style>
